import burger from '../../assets/images/burger.jpg';
import pho from '../../assets/images/pho.jpg';
import tacos from '../../assets/images/tacos.jpg';
import pancakes from '../../assets/images/pancakes.jpg';
import steak from '../../assets/images/steak.jpg';
import shrimp from '../../assets/images/shrimps.jpg';

export default {
  name: 'Menu',
  data() {
    return {
      burger, pho, tacos, pancakes, steak, shrimp,
    };
  },
};
